var map = {
	"./obs_spei3_1951_na_na_na_1_eobs.png": 446112,
	"./spei12_10_2041-2060_25p.png": 216184,
	"./spei12_10_2041-2060_50p.png": 67836,
	"./spei12_10_2041-2060_75p.png": 867380,
	"./spei12_10_2041-2060_allpct.png": 806509,
	"./spei12_10_2061-2080_25p.png": 652400,
	"./spei12_10_2061-2080_50p.png": 388504,
	"./spei12_10_2061-2080_75p.png": 971204,
	"./spei12_10_2061-2080_allpct.png": 192352,
	"./spei12_10_2081-2100_25p.png": 288616,
	"./spei12_10_2081-2100_50p.png": 614928,
	"./spei12_10_2081-2100_75p.png": 189664,
	"./spei12_10_2081-2100_allpct.png": 863828,
	"./spei12_11_2041-2060_25p.png": 174032,
	"./spei12_11_2041-2060_50p.png": 686332,
	"./spei12_11_2041-2060_75p.png": 802948,
	"./spei12_11_2041-2060_allpct.png": 265340,
	"./spei12_11_2061-2080_25p.png": 175893,
	"./spei12_11_2061-2080_50p.png": 550864,
	"./spei12_11_2061-2080_75p.png": 342764,
	"./spei12_11_2061-2080_allpct.png": 10496,
	"./spei12_11_2081-2100_25p.png": 437288,
	"./spei12_11_2081-2100_50p.png": 78468,
	"./spei12_11_2081-2100_75p.png": 744712,
	"./spei12_11_2081-2100_allpct.png": 602292,
	"./spei12_12_2041-2060_25p.png": 412812,
	"./spei12_12_2041-2060_50p.png": 480669,
	"./spei12_12_2041-2060_75p.png": 232220,
	"./spei12_12_2041-2060_allpct.png": 95540,
	"./spei12_12_2061-2080_25p.png": 652871,
	"./spei12_12_2061-2080_50p.png": 98824,
	"./spei12_12_2061-2080_75p.png": 857516,
	"./spei12_12_2061-2080_allpct.png": 229068,
	"./spei12_12_2081-2100_25p.png": 748184,
	"./spei12_12_2081-2100_50p.png": 195460,
	"./spei12_12_2081-2100_75p.png": 473688,
	"./spei12_12_2081-2100_allpct.png": 560816,
	"./spei12_1_2041-2060_25p.png": 437896,
	"./spei12_1_2041-2060_50p.png": 687496,
	"./spei12_1_2041-2060_75p.png": 805372,
	"./spei12_1_2041-2060_allpct.png": 986068,
	"./spei12_1_2061-2080_25p.png": 211780,
	"./spei12_1_2061-2080_50p.png": 811367,
	"./spei12_1_2061-2080_75p.png": 818920,
	"./spei12_1_2061-2080_allpct.png": 437436,
	"./spei12_1_2081-2100_25p.png": 717028,
	"./spei12_1_2081-2100_50p.png": 864620,
	"./spei12_1_2081-2100_75p.png": 607548,
	"./spei12_1_2081-2100_allpct.png": 716956,
	"./spei12_2_2041-2060_25p.png": 712432,
	"./spei12_2_2041-2060_50p.png": 513848,
	"./spei12_2_2041-2060_75p.png": 604756,
	"./spei12_2_2041-2060_allpct.png": 672008,
	"./spei12_2_2061-2080_25p.png": 778192,
	"./spei12_2_2061-2080_50p.png": 967944,
	"./spei12_2_2061-2080_75p.png": 101340,
	"./spei12_2_2061-2080_allpct.png": 765440,
	"./spei12_2_2081-2100_25p.png": 67520,
	"./spei12_2_2081-2100_50p.png": 198228,
	"./spei12_2_2081-2100_75p.png": 388356,
	"./spei12_2_2081-2100_allpct.png": 277488,
	"./spei12_3_2041-2060_25p.png": 437584,
	"./spei12_3_2041-2060_50p.png": 892964,
	"./spei12_3_2041-2060_75p.png": 637100,
	"./spei12_3_2041-2060_allpct.png": 998592,
	"./spei12_3_2061-2080_25p.png": 353348,
	"./spei12_3_2061-2080_50p.png": 433900,
	"./spei12_3_2061-2080_75p.png": 742320,
	"./spei12_3_2061-2080_allpct.png": 91520,
	"./spei12_3_2081-2100_25p.png": 319656,
	"./spei12_3_2081-2100_50p.png": 687560,
	"./spei12_3_2081-2100_75p.png": 386404,
	"./spei12_3_2081-2100_allpct.png": 930768,
	"./spei12_4_2041-2060_25p.png": 785104,
	"./spei12_4_2041-2060_50p.png": 842416,
	"./spei12_4_2041-2060_75p.png": 175888,
	"./spei12_4_2041-2060_allpct.png": 107752,
	"./spei12_4_2061-2080_25p.png": 896176,
	"./spei12_4_2061-2080_50p.png": 773508,
	"./spei12_4_2061-2080_75p.png": 507204,
	"./spei12_4_2061-2080_allpct.png": 583316,
	"./spei12_4_2081-2100_25p.png": 461104,
	"./spei12_4_2081-2100_50p.png": 478784,
	"./spei12_4_2081-2100_75p.png": 131504,
	"./spei12_4_2081-2100_allpct.png": 498648,
	"./spei12_5_2041-2060_25p.png": 423664,
	"./spei12_5_2041-2060_50p.png": 78616,
	"./spei12_5_2041-2060_75p.png": 34692,
	"./spei12_5_2041-2060_allpct.png": 217816,
	"./spei12_5_2061-2080_25p.png": 487580,
	"./spei12_5_2061-2080_50p.png": 852680,
	"./spei12_5_2061-2080_75p.png": 991592,
	"./spei12_5_2061-2080_allpct.png": 715908,
	"./spei12_5_2081-2100_25p.png": 9608,
	"./spei12_5_2081-2100_50p.png": 532496,
	"./spei12_5_2081-2100_75p.png": 329836,
	"./spei12_5_2081-2100_allpct.png": 930476,
	"./spei12_6_2041-2060_25p.png": 59557,
	"./spei12_6_2041-2060_50p.png": 805004,
	"./spei12_6_2041-2060_75p.png": 561356,
	"./spei12_6_2041-2060_allpct.png": 649752,
	"./spei12_6_2061-2080_25p.png": 707532,
	"./spei12_6_2061-2080_50p.png": 673716,
	"./spei12_6_2061-2080_75p.png": 679544,
	"./spei12_6_2061-2080_allpct.png": 801980,
	"./spei12_6_2081-2100_25p.png": 831812,
	"./spei12_6_2081-2100_50p.png": 975136,
	"./spei12_6_2081-2100_75p.png": 117372,
	"./spei12_6_2081-2100_allpct.png": 548992,
	"./spei12_7_2041-2060_25p.png": 44656,
	"./spei12_7_2041-2060_50p.png": 312644,
	"./spei12_7_2041-2060_75p.png": 651636,
	"./spei12_7_2041-2060_allpct.png": 258892,
	"./spei12_7_2061-2080_25p.png": 205588,
	"./spei12_7_2061-2080_50p.png": 471444,
	"./spei12_7_2061-2080_75p.png": 25268,
	"./spei12_7_2061-2080_allpct.png": 857064,
	"./spei12_7_2081-2100_25p.png": 543148,
	"./spei12_7_2081-2100_50p.png": 246800,
	"./spei12_7_2081-2100_75p.png": 266260,
	"./spei12_7_2081-2100_allpct.png": 563596,
	"./spei12_8_2041-2060_25p.png": 130904,
	"./spei12_8_2041-2060_50p.png": 117532,
	"./spei12_8_2041-2060_75p.png": 712776,
	"./spei12_8_2041-2060_allpct.png": 278872,
	"./spei12_8_2061-2080_25p.png": 655460,
	"./spei12_8_2061-2080_50p.png": 521564,
	"./spei12_8_2061-2080_75p.png": 467232,
	"./spei12_8_2061-2080_allpct.png": 802204,
	"./spei12_8_2081-2100_25p.png": 665356,
	"./spei12_8_2081-2100_50p.png": 746628,
	"./spei12_8_2081-2100_75p.png": 460052,
	"./spei12_8_2081-2100_allpct.png": 380864,
	"./spei12_9_2041-2060_25p.png": 211800,
	"./spei12_9_2041-2060_50p.png": 475591,
	"./spei12_9_2041-2060_75p.png": 451104,
	"./spei12_9_2041-2060_allpct.png": 790400,
	"./spei12_9_2061-2080_25p.png": 443160,
	"./spei12_9_2061-2080_50p.png": 613079,
	"./spei12_9_2061-2080_75p.png": 748748,
	"./spei12_9_2061-2080_allpct.png": 170968,
	"./spei12_9_2081-2100_25p.png": 589876,
	"./spei12_9_2081-2100_50p.png": 753936,
	"./spei12_9_2081-2100_75p.png": 627756,
	"./spei12_9_2081-2100_allpct.png": 427656,
	"./spei3_10_2041-2060_25p.png": 103592,
	"./spei3_10_2041-2060_50p.png": 606388,
	"./spei3_10_2041-2060_75p.png": 233924,
	"./spei3_10_2041-2060_allpct.png": 441076,
	"./spei3_10_2061-2080_25p.png": 410340,
	"./spei3_10_2061-2080_50p.png": 85408,
	"./spei3_10_2061-2080_75p.png": 998812,
	"./spei3_10_2061-2080_allpct.png": 316376,
	"./spei3_10_2081-2100_25p.png": 491624,
	"./spei3_10_2081-2100_50p.png": 381228,
	"./spei3_10_2081-2100_75p.png": 227468,
	"./spei3_10_2081-2100_allpct.png": 834528,
	"./spei3_11_2041-2060_25p.png": 225403,
	"./spei3_11_2041-2060_50p.png": 952279,
	"./spei3_11_2041-2060_75p.png": 18480,
	"./spei3_11_2041-2060_allpct.png": 247220,
	"./spei3_11_2061-2080_25p.png": 622476,
	"./spei3_11_2061-2080_50p.png": 189756,
	"./spei3_11_2061-2080_75p.png": 925532,
	"./spei3_11_2061-2080_allpct.png": 640192,
	"./spei3_11_2081-2100_25p.png": 358511,
	"./spei3_11_2081-2100_50p.png": 752196,
	"./spei3_11_2081-2100_75p.png": 56756,
	"./spei3_11_2081-2100_allpct.png": 910220,
	"./spei3_12_2041-2060_25p.png": 297752,
	"./spei3_12_2041-2060_50p.png": 763189,
	"./spei3_12_2041-2060_75p.png": 235949,
	"./spei3_12_2041-2060_allpct.png": 851016,
	"./spei3_12_2061-2080_25p.png": 176424,
	"./spei3_12_2061-2080_50p.png": 368368,
	"./spei3_12_2061-2080_75p.png": 460436,
	"./spei3_12_2061-2080_allpct.png": 13268,
	"./spei3_12_2081-2100_25p.png": 628336,
	"./spei3_12_2081-2100_50p.png": 797824,
	"./spei3_12_2081-2100_75p.png": 334396,
	"./spei3_12_2081-2100_allpct.png": 114192,
	"./spei3_1_2041-2060_25p.png": 228736,
	"./spei3_1_2041-2060_50p.png": 5792,
	"./spei3_1_2041-2060_75p.png": 616712,
	"./spei3_1_2041-2060_allpct.png": 925884,
	"./spei3_1_2061-2080_25p.png": 858416,
	"./spei3_1_2061-2080_50p.png": 749168,
	"./spei3_1_2061-2080_75p.png": 235372,
	"./spei3_1_2061-2080_allpct.png": 339788,
	"./spei3_1_2081-2100_25p.png": 683704,
	"./spei3_1_2081-2100_50p.png": 102420,
	"./spei3_1_2081-2100_75p.png": 553696,
	"./spei3_1_2081-2100_allpct.png": 804372,
	"./spei3_2_2041-2060_25p.png": 940092,
	"./spei3_2_2041-2060_50p.png": 890579,
	"./spei3_2_2041-2060_75p.png": 327184,
	"./spei3_2_2041-2060_allpct.png": 722892,
	"./spei3_2_2061-2080_25p.png": 2024,
	"./spei3_2_2061-2080_50p.png": 839152,
	"./spei3_2_2061-2080_75p.png": 364436,
	"./spei3_2_2061-2080_allpct.png": 15916,
	"./spei3_2_2081-2100_25p.png": 208860,
	"./spei3_2_2081-2100_50p.png": 962456,
	"./spei3_2_2081-2100_75p.png": 532796,
	"./spei3_2_2081-2100_allpct.png": 237612,
	"./spei3_3_2041-2060_25p.png": 116364,
	"./spei3_3_2041-2060_50p.png": 372440,
	"./spei3_3_2041-2060_75p.png": 7208,
	"./spei3_3_2041-2060_allpct.png": 99764,
	"./spei3_3_2061-2080_25p.png": 7068,
	"./spei3_3_2061-2080_50p.png": 435300,
	"./spei3_3_2061-2080_75p.png": 232052,
	"./spei3_3_2061-2080_allpct.png": 592072,
	"./spei3_3_2081-2100_25p.png": 761400,
	"./spei3_3_2081-2100_50p.png": 24256,
	"./spei3_3_2081-2100_75p.png": 153308,
	"./spei3_3_2081-2100_allpct.png": 393848,
	"./spei3_4_2041-2060_25p.png": 281240,
	"./spei3_4_2041-2060_50p.png": 798892,
	"./spei3_4_2041-2060_75p.png": 964799,
	"./spei3_4_2041-2060_allpct.png": 160816,
	"./spei3_4_2061-2080_25p.png": 680152,
	"./spei3_4_2061-2080_50p.png": 542020,
	"./spei3_4_2061-2080_75p.png": 293140,
	"./spei3_4_2061-2080_allpct.png": 25656,
	"./spei3_4_2081-2100_25p.png": 686428,
	"./spei3_4_2081-2100_50p.png": 170876,
	"./spei3_4_2081-2100_75p.png": 981160,
	"./spei3_4_2081-2100_allpct.png": 418692,
	"./spei3_5_2041-2060_25p.png": 895444,
	"./spei3_5_2041-2060_50p.png": 910992,
	"./spei3_5_2041-2060_75p.png": 501764,
	"./spei3_5_2041-2060_allpct.png": 26488,
	"./spei3_5_2061-2080_25p.png": 687264,
	"./spei3_5_2061-2080_50p.png": 376072,
	"./spei3_5_2061-2080_75p.png": 919780,
	"./spei3_5_2061-2080_allpct.png": 941592,
	"./spei3_5_2081-2100_25p.png": 615180,
	"./spei3_5_2081-2100_50p.png": 689204,
	"./spei3_5_2081-2100_75p.png": 128288,
	"./spei3_5_2081-2100_allpct.png": 183816,
	"./spei3_6_2041-2060_25p.png": 98300,
	"./spei3_6_2041-2060_50p.png": 444068,
	"./spei3_6_2041-2060_75p.png": 839316,
	"./spei3_6_2041-2060_allpct.png": 28056,
	"./spei3_6_2061-2080_25p.png": 503896,
	"./spei3_6_2061-2080_50p.png": 284796,
	"./spei3_6_2061-2080_75p.png": 854492,
	"./spei3_6_2061-2080_allpct.png": 183828,
	"./spei3_6_2081-2100_25p.png": 721684,
	"./spei3_6_2081-2100_50p.png": 150976,
	"./spei3_6_2081-2100_75p.png": 532340,
	"./spei3_6_2081-2100_allpct.png": 210653,
	"./spei3_7_2041-2060_25p.png": 391831,
	"./spei3_7_2041-2060_50p.png": 952532,
	"./spei3_7_2041-2060_75p.png": 593332,
	"./spei3_7_2041-2060_allpct.png": 565180,
	"./spei3_7_2061-2080_25p.png": 572616,
	"./spei3_7_2061-2080_50p.png": 916920,
	"./spei3_7_2061-2080_75p.png": 560157,
	"./spei3_7_2061-2080_allpct.png": 553492,
	"./spei3_7_2081-2100_25p.png": 424248,
	"./spei3_7_2081-2100_50p.png": 396328,
	"./spei3_7_2081-2100_75p.png": 93535,
	"./spei3_7_2081-2100_allpct.png": 93192,
	"./spei3_8_2041-2060_25p.png": 48461,
	"./spei3_8_2041-2060_50p.png": 324012,
	"./spei3_8_2041-2060_75p.png": 237480,
	"./spei3_8_2041-2060_allpct.png": 940832,
	"./spei3_8_2061-2080_25p.png": 848988,
	"./spei3_8_2061-2080_50p.png": 761756,
	"./spei3_8_2061-2080_75p.png": 895152,
	"./spei3_8_2061-2080_allpct.png": 519124,
	"./spei3_8_2081-2100_25p.png": 333456,
	"./spei3_8_2081-2100_50p.png": 652448,
	"./spei3_8_2081-2100_75p.png": 455872,
	"./spei3_8_2081-2100_allpct.png": 156340,
	"./spei3_9_2041-2060_25p.png": 569148,
	"./spei3_9_2041-2060_50p.png": 690739,
	"./spei3_9_2041-2060_75p.png": 604316,
	"./spei3_9_2041-2060_allpct.png": 941832,
	"./spei3_9_2061-2080_25p.png": 473244,
	"./spei3_9_2061-2080_50p.png": 395780,
	"./spei3_9_2061-2080_75p.png": 608016,
	"./spei3_9_2061-2080_allpct.png": 235036,
	"./spei3_9_2081-2100_25p.png": 509128,
	"./spei3_9_2081-2100_50p.png": 529044,
	"./spei3_9_2081-2100_75p.png": 139060,
	"./spei3_9_2081-2100_allpct.png": 583092,
	"./spei6_10_2041-2060_25p.png": 648680,
	"./spei6_10_2041-2060_50p.png": 307020,
	"./spei6_10_2041-2060_75p.png": 162028,
	"./spei6_10_2041-2060_allpct.png": 117584,
	"./spei6_10_2061-2080_25p.png": 401884,
	"./spei6_10_2061-2080_50p.png": 5744,
	"./spei6_10_2061-2080_75p.png": 906091,
	"./spei6_10_2061-2080_allpct.png": 683436,
	"./spei6_10_2081-2100_25p.png": 696788,
	"./spei6_10_2081-2100_50p.png": 712336,
	"./spei6_10_2081-2100_75p.png": 704016,
	"./spei6_10_2081-2100_allpct.png": 987928,
	"./spei6_11_2041-2060_25p.png": 450000,
	"./spei6_11_2041-2060_50p.png": 479048,
	"./spei6_11_2041-2060_75p.png": 959192,
	"./spei6_11_2041-2060_allpct.png": 231216,
	"./spei6_11_2061-2080_25p.png": 259852,
	"./spei6_11_2061-2080_50p.png": 707540,
	"./spei6_11_2061-2080_75p.png": 652376,
	"./spei6_11_2061-2080_allpct.png": 626936,
	"./spei6_11_2081-2100_25p.png": 759508,
	"./spei6_11_2081-2100_50p.png": 390912,
	"./spei6_11_2081-2100_75p.png": 237152,
	"./spei6_11_2081-2100_allpct.png": 348008,
	"./spei6_12_2041-2060_25p.png": 818636,
	"./spei6_12_2041-2060_50p.png": 136816,
	"./spei6_12_2041-2060_75p.png": 662100,
	"./spei6_12_2041-2060_allpct.png": 182424,
	"./spei6_12_2061-2080_25p.png": 526080,
	"./spei6_12_2061-2080_50p.png": 199304,
	"./spei6_12_2061-2080_75p.png": 787224,
	"./spei6_12_2061-2080_allpct.png": 390104,
	"./spei6_12_2081-2100_25p.png": 86200,
	"./spei6_12_2081-2100_50p.png": 660836,
	"./spei6_12_2081-2100_75p.png": 308360,
	"./spei6_12_2081-2100_allpct.png": 238768,
	"./spei6_1_2041-2060_25p.png": 185435,
	"./spei6_1_2041-2060_50p.png": 69479,
	"./spei6_1_2041-2060_75p.png": 243508,
	"./spei6_1_2041-2060_allpct.png": 174788,
	"./spei6_1_2061-2080_25p.png": 157492,
	"./spei6_1_2061-2080_50p.png": 799483,
	"./spei6_1_2061-2080_75p.png": 526972,
	"./spei6_1_2061-2080_allpct.png": 528964,
	"./spei6_1_2081-2100_25p.png": 634580,
	"./spei6_1_2081-2100_50p.png": 766364,
	"./spei6_1_2081-2100_75p.png": 486884,
	"./spei6_1_2081-2100_allpct.png": 392016,
	"./spei6_2_2041-2060_25p.png": 687880,
	"./spei6_2_2041-2060_50p.png": 288600,
	"./spei6_2_2041-2060_75p.png": 40812,
	"./spei6_2_2041-2060_allpct.png": 84109,
	"./spei6_2_2061-2080_25p.png": 22160,
	"./spei6_2_2061-2080_50p.png": 984636,
	"./spei6_2_2061-2080_75p.png": 346068,
	"./spei6_2_2061-2080_allpct.png": 627764,
	"./spei6_2_2081-2100_25p.png": 456112,
	"./spei6_2_2081-2100_50p.png": 448855,
	"./spei6_2_2081-2100_75p.png": 976636,
	"./spei6_2_2081-2100_allpct.png": 907596,
	"./spei6_3_2041-2060_25p.png": 895472,
	"./spei6_3_2041-2060_50p.png": 542824,
	"./spei6_3_2041-2060_75p.png": 738664,
	"./spei6_3_2041-2060_allpct.png": 374136,
	"./spei6_3_2061-2080_25p.png": 754836,
	"./spei6_3_2061-2080_50p.png": 621368,
	"./spei6_3_2061-2080_75p.png": 553688,
	"./spei6_3_2061-2080_allpct.png": 489100,
	"./spei6_3_2081-2100_25p.png": 616692,
	"./spei6_3_2081-2100_50p.png": 684244,
	"./spei6_3_2081-2100_75p.png": 496040,
	"./spei6_3_2081-2100_allpct.png": 323688,
	"./spei6_4_2041-2060_25p.png": 14044,
	"./spei6_4_2041-2060_50p.png": 417196,
	"./spei6_4_2041-2060_75p.png": 786893,
	"./spei6_4_2041-2060_allpct.png": 227892,
	"./spei6_4_2061-2080_25p.png": 752292,
	"./spei6_4_2061-2080_50p.png": 103980,
	"./spei6_4_2061-2080_75p.png": 716284,
	"./spei6_4_2061-2080_allpct.png": 533796,
	"./spei6_4_2081-2100_25p.png": 170628,
	"./spei6_4_2081-2100_50p.png": 644472,
	"./spei6_4_2081-2100_75p.png": 549740,
	"./spei6_4_2081-2100_allpct.png": 78200,
	"./spei6_5_2041-2060_25p.png": 259564,
	"./spei6_5_2041-2060_50p.png": 494304,
	"./spei6_5_2041-2060_75p.png": 84324,
	"./spei6_5_2041-2060_allpct.png": 408288,
	"./spei6_5_2061-2080_25p.png": 689500,
	"./spei6_5_2061-2080_50p.png": 684516,
	"./spei6_5_2061-2080_75p.png": 597172,
	"./spei6_5_2061-2080_allpct.png": 474667,
	"./spei6_5_2081-2100_25p.png": 220696,
	"./spei6_5_2081-2100_50p.png": 640948,
	"./spei6_5_2081-2100_75p.png": 654496,
	"./spei6_5_2081-2100_allpct.png": 295224,
	"./spei6_6_2041-2060_25p.png": 103444,
	"./spei6_6_2041-2060_50p.png": 15292,
	"./spei6_6_2041-2060_75p.png": 211016,
	"./spei6_6_2041-2060_allpct.png": 7744,
	"./spei6_6_2061-2080_25p.png": 40672,
	"./spei6_6_2061-2080_50p.png": 68104,
	"./spei6_6_2061-2080_75p.png": 386232,
	"./spei6_6_2061-2080_allpct.png": 971956,
	"./spei6_6_2081-2100_25p.png": 503516,
	"./spei6_6_2081-2100_50p.png": 856504,
	"./spei6_6_2081-2100_75p.png": 381088,
	"./spei6_6_2081-2100_allpct.png": 395744,
	"./spei6_7_2041-2060_25p.png": 569528,
	"./spei6_7_2041-2060_50p.png": 266156,
	"./spei6_7_2041-2060_75p.png": 796912,
	"./spei6_7_2041-2060_allpct.png": 600412,
	"./spei6_7_2061-2080_25p.png": 568363,
	"./spei6_7_2061-2080_50p.png": 262668,
	"./spei6_7_2061-2080_75p.png": 66648,
	"./spei6_7_2061-2080_allpct.png": 183788,
	"./spei6_7_2081-2100_25p.png": 137936,
	"./spei6_7_2081-2100_50p.png": 151264,
	"./spei6_7_2081-2100_75p.png": 858064,
	"./spei6_7_2081-2100_allpct.png": 361240,
	"./spei6_8_2041-2060_25p.png": 3336,
	"./spei6_8_2041-2060_50p.png": 592412,
	"./spei6_8_2041-2060_75p.png": 263932,
	"./spei6_8_2041-2060_allpct.png": 991568,
	"./spei6_8_2061-2080_25p.png": 173308,
	"./spei6_8_2061-2080_50p.png": 317024,
	"./spei6_8_2061-2080_75p.png": 473376,
	"./spei6_8_2061-2080_allpct.png": 896240,
	"./spei6_8_2081-2100_25p.png": 895064,
	"./spei6_8_2081-2100_50p.png": 882300,
	"./spei6_8_2081-2100_75p.png": 597560,
	"./spei6_8_2081-2100_allpct.png": 554076,
	"./spei6_9_2041-2060_25p.png": 287380,
	"./spei6_9_2041-2060_50p.png": 376292,
	"./spei6_9_2041-2060_75p.png": 86232,
	"./spei6_9_2041-2060_allpct.png": 593548,
	"./spei6_9_2061-2080_25p.png": 570264,
	"./spei6_9_2061-2080_50p.png": 716140,
	"./spei6_9_2061-2080_75p.png": 258812,
	"./spei6_9_2061-2080_allpct.png": 284824,
	"./spei6_9_2081-2100_25p.png": 721996,
	"./spei6_9_2081-2100_50p.png": 201872,
	"./spei6_9_2081-2100_75p.png": 373332,
	"./spei6_9_2081-2100_allpct.png": 55448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 862864;